import script from "./ant-set.vue?vue&type=script&setup=true&lang=js"
export * from "./ant-set.vue?vue&type=script&setup=true&lang=js"

import "./ant-set.vue?vue&type=style&index=0&id=67011f0e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67011f0e"]])

export default __exports__